import React, { lazy, useMemo } from "react";
import { useRootElement } from "../context";
import * as styles from "./styles";
import type { BaseMapProps } from "./types";

const MapGLBaseMap = lazy(() => import("./MapGL"));

export const BaseMap = ({ children, bounds }: BaseMapProps) => {
  const { mapProvider } = useRootElement();

  const MapProvider = useMemo(() => {
    switch (mapProvider?.name) {
      default:
        return MapGLBaseMap;
    }
  }, [mapProvider]);

  return (
    <MapProvider bounds={bounds}>
      <div className={styles.container}>{children}</div>
    </MapProvider>
  );
};
